module.exports = __webpack_public_path__ + "img/it_seguromovil.7a26ef55.png";